import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{!-- UI nuova «scollega» confirm (one piece for the chip ✕, the record preview «scollega» and the combobox re-click).\n     @busy locks every close path while the unlink runs; portaled under <body> by BbModalModern. --}}\n<BbModalModern\n  @isOpen={{@isOpen}}\n  @title=\'{{nv-cap (t \"remove relationship\")}} {{@label}}\'\n  @alert={{true}}\n  @size=\'small\'\n  @onClose={{this.cancel}}\n  @busy={{this.running}}\n  @zIndex={{this.zIndex}}\n  data-test-unlink-confirm\n  ...attributes\n>\n  <:main>\n    <p>{{nv-cap (t \'are you sure?\')}}</p>\n  </:main>\n  <:footer>\n    <div class=\'nv-st-actions\'>\n      <button\n        type=\'button\'\n        class=\'nv-btn nv-btn--danger nv-st-actions-start\'\n        aria-busy={{if this.running \'true\'}}\n        disabled={{this.running}}\n        data-test-unlink-confirm-yes\n        {{on \'click\' this.confirm}}\n      ><FaIcon @icon=\'unlink\' aria-hidden=\'true\' />{{nv-cap (t \'yes\')}}</button>\n      <button\n        type=\'button\'\n        class=\'nv-btn\'\n        disabled={{this.running}}\n        data-test-unlink-confirm-no\n        {{did-insert this.focusCancel}}\n        {{on \'click\' this.cancel}}\n      >{{nv-cap (t \'no\')}}</button>\n    </div>\n  </:footer>\n</BbModalModern>\n");

var _class;
let BbUnlinkConfirmComponent = (_class = class BbUnlinkConfirmComponent extends Component {
  get running() {
    return this.confirmTask.isRunning || !!this.args.busy;
  }
  get zIndex() {
    return this.args.zIndex ?? '1120';
  }

  // «No», ✕, backdrop, Escape (BbModalModern ignores them while @busy): keep the link
  cancel() {
    if (this.running) return;
    this.args.onClose?.();
  }
  confirm() {
    this.confirmTask.perform();
  }

  // the safe default answer has the focus when the confirm opens
  focusCancel(element) {
    element.focus();
  }
  *confirmTask() {
    const onConfirm = this.args.onConfirm;
    const onClose = this.args.onClose;
    if (typeof onConfirm !== 'function') return;
    try {
      yield Promise.resolve(onConfirm());
    } finally {
      // still here = refused (the record stays, the caller already notified), a draft-only change, or a host that
      // outlives the unlink (the combobox): it closes the confirm and puts the focus back
      if (!this.isDestroying && !this.isDestroyed) onClose?.();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusCancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusCancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "confirmTask"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbUnlinkConfirmComponent);

export { BbUnlinkConfirmComponent as default };
//# sourceMappingURL=bb-unlink-confirm.js.map
